import { inject, InjectionToken } from '@angular/core';
import { Store } from '@sama/app-state';
import { ObjectWith } from '../../3d/utils/misc-utils';
import { TaskWorkspaceStore } from '../../core/h3ml/state/task-workspace-store';
import { ViewMode } from './abstract-sensor-content-state';
import { CalibrationOptions } from './calibration-options-state';
import { EnhancedCloudSettingsState } from './enhanced-point-cloud-setting-state';
import {
  DEFAULT_OPACITY,
  LayerSettingsState2D,
} from './layer-settings-state-2d';
import { LayerSettingsState3D } from './layer-settings-state-3d';
import { RegionOfInterestState } from './region-of-interest-state';

export class SettingState {
  areProjectionsEnabled = true;
  calibrationOptions: ObjectWith<CalibrationOptions> = {};
  enhancedCloudSettings = new EnhancedCloudSettingsState();
  inspectMode = false;
  hideGround = false;
  showCloudProjection = false;
  showShapeProjection = true;
  showRoute = true;
  topViewHiddenInSplitView = true;
  useOrthographicCamera = false;
  zoomPanel = {
    isOpen: false,
  };
  viewMode: ViewMode = 'all';
  layerSettings3d = new LayerSettingsState3D({});
  layerSettings2d = new LayerSettingsState2D(DEFAULT_OPACITY);
  useEvenSplit = false;
  regionOfInterestSettings = new RegionOfInterestState();
  viewBoxHighlightEnabled = false;
}

export const settingsStoreToken = new InjectionToken<Store<SettingState>>(
  'settings',
  {
    factory: () => inject(TaskWorkspaceStore)('settings'),
  },
);

export function getDefaultCalibrationOptions(): CalibrationOptions {
  return {
    initialRotation: [0, 0, 0],
    quaternionFormatCorrections: 'none',
    shouldInvert: false,
    showAxesHelper: false,
  };
}
